// Status options - DEPRECATED: Colors should come from database
// These are kept for backward compatibility but should be replaced with database values
export const TICKET_STATUS_OPTIONS = [
  { value: 'open', label: 'Open', color: '#ef4444' },
  { value: 'in_progress', label: 'In Progress', color: '#3b82f6' },
  { value: 'completed', label: 'Completed', color: '#10b981' },
  { value: 'paused', label: 'On Hold', color: '#374151' }
];

export const TICKET_STATUS_OPTIONS_EN = [
  { value: 'open', label: 'Open', color: '#ef4444' },
  { value: 'in_progress', label: 'In Progress', color: '#3b82f6' },
  { value: 'completed', label: 'Completed', color: '#10b981' },
  { value: 'paused', label: 'On Hold', color: '#374151' }
];

export const TICKET_STATUS_OPTIONS_TR = [
  { value: 'open', label: 'Açık', color: '#ef4444' },
  { value: 'in_progress', label: 'Devam Ediyor', color: '#3b82f6' },
  { value: 'completed', label: 'Tamamlandı', color: '#10b981' },
  { value: 'paused', label: 'Beklemede', color: '#374151' }
];

// Priority options
export const TICKET_PRIORITY_OPTIONS = [
  { value: 'Niedrig', label: 'Niedrig', color: '#10b981' },
  { value: 'Mittel', label: 'Mittel', color: '#f59e0b' },
  { value: 'Hoch', label: 'Hoch', color: '#ef4444' },
  { value: 'Kritisch', label: 'Kritisch', color: '#dc2626' }
];

export const TICKET_PRIORITY_OPTIONS_EN = [
  { value: 'Niedrig', label: 'Low', color: '#10b981' },
  { value: 'Mittel', label: 'Medium', color: '#f59e0b' },
  { value: 'Hoch', label: 'High', color: '#ef4444' },
  { value: 'Kritisch', label: 'Critical', color: '#dc2626' }
];

export const TICKET_PRIORITY_OPTIONS_TR = [
  { value: 'Niedrig', label: 'Düşük', color: '#10b981' },
  { value: 'Mittel', label: 'Orta', color: '#f59e0b' },
  { value: 'Hoch', label: 'Yüksek', color: '#ef4444' },
  { value: 'Kritisch', label: 'Kritik', color: '#dc2626' }
];

// Tab options
export const PROJECT_TABS = [
  { id: 'details', label: 'Details', icon: 'Info' },
  { id: 'settings', label: 'Einstellungen', icon: 'Settings' },
  { id: 'team', label: 'Team', icon: 'Users' },
  { id: 'groups', label: 'Gruppen', icon: 'UserGroup' },
  { id: 'planLevel', label: 'Plan-Ebene', icon: 'Map' },
  { id: 'tickets', label: 'Tickets', icon: 'Ticket' },
  { id: 'documents', label: 'Dokumente', icon: 'FileText' }
];

// Sort options
export const SORT_OPTIONS = [
  { value: 'name', label: 'Name' },
  { value: 'date', label: 'Datum' },
  { value: 'size', label: 'Größe' },
  { value: 'status', label: 'Status' },
  { value: 'priority', label: 'Priorität' }
];

export const SORT_ORDER_OPTIONS = [
  { value: 'asc', label: 'Aufsteigend' },
  { value: 'desc', label: 'Absteigend' }
];

// Filter options
export const FILTER_OPTIONS = {
  status: TICKET_STATUS_OPTIONS,
  priority: TICKET_PRIORITY_OPTIONS,
  sortBy: SORT_OPTIONS,
  sortOrder: SORT_ORDER_OPTIONS
};

// File type options
export const SUPPORTED_FILE_TYPES = [
  { type: 'application/pdf', label: 'PDF', icon: 'FileText' },
  { type: 'image/jpeg', label: 'JPEG', icon: 'Image' },
  { type: 'image/png', label: 'PNG', icon: 'Image' },
  { type: 'image/gif', label: 'GIF', icon: 'Image' },
  { type: 'application/msword', label: 'Word', icon: 'File' },
  { type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', label: 'Word', icon: 'File' },
  { type: 'application/vnd.ms-excel', label: 'Excel', icon: 'FileSpreadsheet' },
  { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', label: 'Excel', icon: 'FileSpreadsheet' }
];

// Default values
export const DEFAULT_VALUES = {
  project: {
    priority: 'Mittel',
    planLevel: 1
  },
  ticket: {
    status: 'open',
    priority: 'Mittel',
    gewerk: '',
    assignee: ''
  },
  document: {
    sortBy: 'date',
    sortOrder: 'desc' as const
  },
  team: {
    sortBy: 'name',
    sortOrder: 'asc' as const
  }
};

// Pagination options
export const PAGINATION_OPTIONS = [
  { value: 10, label: '10 pro Seite' },
  { value: 25, label: '25 pro Seite' },
  { value: 50, label: '50 pro Seite' },
  { value: 100, label: '100 pro Seite' }
];

// Date format options
export const DATE_FORMAT_OPTIONS = [
  { value: 'dd.MM.yyyy', label: 'DD.MM.YYYY' },
  { value: 'MM/dd/yyyy', label: 'MM/DD/YYYY' },
  { value: 'yyyy-MM-dd', label: 'YYYY-MM-DD' }
];

// Time format options
export const TIME_FORMAT_OPTIONS = [
  { value: 'HH:mm', label: '24 Stunden' },
  { value: 'hh:mm a', label: '12 Stunden' }
];

// Color schemes
export const COLOR_SCHEMES = {
  primary: '#3b82f6',
  secondary: '#6b7280',
  success: '#10b981',
  warning: '#f59e0b',
  error: '#ef4444',
  info: '#06b6d4'
};

// Status colors
export const STATUS_COLORS = {
  open: '#ef4444',
  inProgress: '#3b82f6',
  completed: '#10b981',
  onHold: '#374151'
};

// Priority colors
export const PRIORITY_COLORS = {
  low: '#10b981',
  medium: '#f59e0b',
  high: '#ef4444',
  critical: '#dc2626'
};

// Icon mappings
export const ICON_MAPPINGS = {
  status: {
    open: 'Circle',
    in_progress: 'Clock',
    completed: 'CheckCircle',
    paused: 'Pause'
  },
  priority: {
    'Niedrig': 'ArrowDown',
    'Mittel': 'Minus',
    'Hoch': 'ArrowUp',
    'Kritisch': 'AlertTriangle'
  },
  fileType: {
    'application/pdf': 'FileText',
    'image/jpeg': 'Image',
    'image/png': 'Image',
    'image/gif': 'Image',
    'application/msword': 'File',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'File',
    'application/vnd.ms-excel': 'FileSpreadsheet',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'FileSpreadsheet'
  }
};

// API endpoints
export const API_ENDPOINTS = {
  projects: '/api/projects',
  tickets: '/api/tickets',
  documents: '/api/documents',
  team: '/api/contractors',
  groups: '/api/groups',
  plans: '/api/plans',
  gewerke: '/api/gewerke',
  bauzeitenplan: '/api/bauzeitenplan'
};

// Query keys
export const QUERY_KEYS = {
  projects: ['/api/projects'],
  project: (id: string) => ['/api/projects', id],
  tickets: ['/api/tickets'],
  projectTickets: (projectId: string) => ['/api/tickets', 'project', projectId],
  documents: ['/api/documents'],
  projectDocuments: (projectId: string) => ['/api/documents', 'project', projectId],
  team: ['/api/contractors'],
  projectTeam: (projectId: string) => ['/api/contractors', 'project', projectId],
  groups: ['/api/groups'],
  plans: ['/api/plans'],
  projectPlans: (projectId: string) => ['/api/plans', 'project', projectId],
  gewerke: ['/api/gewerke'],
  bauzeitenplan: (projectId: string) => ['/api/bauzeitenplan', projectId]
};

// Local storage keys
export const STORAGE_KEYS = {
  projectFilters: 'project-filters',
  ticketFilters: 'ticket-filters',
  documentFilters: 'document-filters',
  teamFilters: 'team-filters',
  userPreferences: 'user-preferences',
  lastActiveTab: 'last-active-tab',
  pdfZoomStep: 'pdf-zoom-step'
};

// Validation rules
export const VALIDATION_RULES = {
  projectNumber: {
    pattern: /^\d{3}-\d{3}-\d{4}$/,
    message: 'Projektnummer muss im Format XXX-XXX-XXXX sein'
  },
  email: {
    pattern: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
    message: 'Bitte geben Sie eine gültige E-Mail-Adresse ein'
  },
  phone: {
    pattern: /^[\+]?[1-9][\d]{0,15}$/,
    message: 'Bitte geben Sie eine gültige Telefonnummer ein'
  },
  url: {
    pattern: /^https?:\/\/.+/,
    message: 'Bitte geben Sie eine gültige URL ein'
  }
};

// Error messages
export const ERROR_MESSAGES = {
  network: 'Netzwerkfehler. Bitte versuchen Sie es erneut.',
  unauthorized: 'Sie sind nicht berechtigt, diese Aktion auszuführen.',
  notFound: 'Die angeforderte Ressource wurde nicht gefunden.',
  serverError: 'Ein Serverfehler ist aufgetreten. Bitte versuchen Sie es später erneut.',
  validation: 'Bitte überprüfen Sie Ihre Eingaben.',
  fileUpload: 'Fehler beim Hochladen der Datei.',
  fileDelete: 'Fehler beim Löschen der Datei.',
  save: 'Fehler beim Speichern.',
  delete: 'Fehler beim Löschen.'
};

// Success messages
export const SUCCESS_MESSAGES = {
  saved: 'Erfolgreich gespeichert.',
  deleted: 'Erfolgreich gelöscht.',
  uploaded: 'Datei erfolgreich hochgeladen.',
  created: 'Erfolgreich erstellt.',
  updated: 'Erfolgreich aktualisiert.'
};

// Animation durations
export const ANIMATION_DURATIONS = {
  fast: 150,
  normal: 300,
  slow: 500
};

// Breakpoints
export const BREAKPOINTS = {
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  '2xl': 1536
};

// Z-index values
export const Z_INDEX = {
  dropdown: 1000,
  modal: 1050,
  popover: 1100,
  tooltip: 1200,
  notification: 1300
};
